import { render, staticRenderFns } from "./setFunction.vue?vue&type=template&id=2a85cf29"
import script from "./setFunction.vue?vue&type=script&lang=js"
export * from "./setFunction.vue?vue&type=script&lang=js"
import style0 from "./setFunction.vue?vue&type=style&index=0&id=2a85cf29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports